import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { endpoints } from 'src/environments/endpoints';

import { Usuario } from '../../models/auth/Usuario';
import { AlterarSenhaUsuarioPayload } from '../../models/usuario/AlterarSenhaUsuarioPayload';
import { AlterarUsuarioPayload } from '../../models/usuario/AlterarUsuarioPayload';
import { toFormData } from '../../utils/toFormData';
import { AlterarUsuarioLogadoPayload } from '../../models/usuario/AlterarUsuarioLogadoPayload';
import { UsuarioPainelDeAtendimento } from '../../models/auth/UsuarioPainelDeAtendimento';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  http = inject(HttpClient);

  private baseUrl = endpoints.usuarios;

  obterUsuarioLogado(): Observable<Usuario> {
    return this.http.get<Usuario>(endpoints.usuarios);
  }

  alterarUsuarioLogado(payload: AlterarUsuarioLogadoPayload): Observable<void> {
    const url = `${this.baseUrl}/minha-conta`;

    return this.http.put<void>(url, toFormData(payload));
  }

  obterUsuarioPeloGuid(guidUsuario: string): Observable<Usuario> {
    const url = `${this.baseUrl}/${guidUsuario}`;

    return this.http.get<Usuario>(url);
  }

  alterarUsuario(payload: AlterarUsuarioPayload): Observable<void> {
    return this.http.put<void>(this.baseUrl, toFormData(payload));
  }

  alterarSenhaUsuario(payload: AlterarSenhaUsuarioPayload): Observable<void> {
    const url = `${this.baseUrl}/alterar-senha`;

    return this.http.put<void>(url, payload);
  }

  obterUsuariosPainelDeAtendimento(
    nome?: string,
    email?: string
  ): Observable<UsuarioPainelDeAtendimento[]> {
    const url = `${this.baseUrl}/painel-de-atendimento`;
    let params = new HttpParams();

    if (nome) {
      params.set('filtroNome', nome);
    }

    if (email) {
      params.set('filtroEmail', email);
    }

    return this.http.get<UsuarioPainelDeAtendimento[]>(url, { params });
  }
}
